import { render, staticRenderFns } from "./AccesoDenegado.vue?vue&type=template&id=befe3574&scoped=true"
import script from "./AccesoDenegado.vue?vue&type=script&setup=true&lang=js"
export * from "./AccesoDenegado.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccesoDenegado.vue?vue&type=style&index=0&id=befe3574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befe3574",
  null
  
)

export default component.exports